export const XPERIENCE_LOGIN_TAG_NAME = 'tm-bo-xperience-login';
